



























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';
import TransportCostsForm from './TransportCostsForm/TransportCostsForm.vue'
import TransportCostsManyForm from './TransportCostsManyForm/TransportCostsManyForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
// @ts-ignore
import { MonthPicker } from 'vue-month-picker'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta',

      'filter',

      'documents', 'lastMeta', 'active_accept',
    ]),
    ...mapGetters(STORE_KEY, [
      'byMonthy'
    ])
  },
  components: {
    TitleBar,
    MonthPicker
  }
})
export default class EmployeeList extends Vue {
  radioButton = 1;
  deliveryZoneGroup: any = null;
  targetDates: any[] = [];
  byMonthy!: any;
  selectedDate: any = null;

  get titleStack () {
    return [
      'Внесение транспортных расходов'
    ]
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'date', this.$route.query.sortDirection || 'desc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  confirmDeleteTransportCosts(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить запись на сумму ${row.costs} руб. (клиент: ${row.client_name}, зона: ${row.delivery_zone_name})`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/deleteTransportCost`, {
          id: row.id
        })
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
          this.handleParamsChange();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  setDate(date: any) {
    this.selectedDate = date
    this.$store.dispatch(`${STORE_KEY}/setActiveAccept`, date.monthIndex - 1)
  }

  acceptMonth() {
    this.$buefy.dialog.confirm({
      message: `Согласовать транспортные затраты за ` + this.selectedDate.month + ' ' + this.selectedDate.year,
      confirmText: 'Согласовать',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/acceptMonth`)
        .then((result) => {
          this.$buefy.snackbar.open(`Месяц согласован`);
          this.handleParamsChange();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  get months() {
    return [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь'
    ].map((item: any, idx: number) => {
      return item + (this.byMonthy[idx] && this.byMonthy[idx].is_accepted ? ' [+]' : '')
    })
  }

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  onZoneChange(delivery_zone_group_id: string) {
    console.log('onZoneChange', delivery_zone_group_id)
    this.$router.replace({
      query: { ...this.$route.query, delivery_zone_group_id }
    })
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  openTransportCostsForm(row: any, many: boolean) {
    console.log(many)
    this.$buefy.modal.open({
      component: many ? TransportCostsManyForm : TransportCostsForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: many ? 'document-form' : 'document-form short-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (!this.$route.query.since) {
      this.onDatesChange([
        moment().startOf('month'),
        moment()
      ])
    } else {
      this.handleParamsChange();
    }
    this.$store.dispatch(`${STORE_KEY}/setActiveAccept`, 0)
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query.delivery_zone_group_id) {
      this.deliveryZoneGroup = this.$route.query.delivery_zone_group_id
    }
    this.targetDates = [
      // @ts-ignore
      moment(this.$route.query.since).toDate(),
      // @ts-ignore
      moment(this.$route.query.until).toDate()
    ]
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
